import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";

import IconSprite from "../components/IconSprite";
import Sidebar from "./Sidebar";
import TabBar from "./TabBar";

/**
 * Top-level layout: hosts the icon sprite, sidebar, main content area, and
 * mobile tab-bar. The `page page--{route}` body classes drive a few
 * route-specific style hooks in styles.css.
 *
 * The `<Outlet />` is wrapped in an `AnimatePresence`/`motion.div` keyed on
 * pathname, so swapping routes (Overview ↔ Analysis) cross-fades instead
 * of snapping. Respects `prefers-reduced-motion`.
 */
export default function AppLayout() {
  const { pathname } = useLocation();
  const activePage = pathname === "/analysis" ? "analysis" : "main";
  const reduce = useReducedMotion();

  // Mirror the legacy `<body class="page page--{active_page}">` hook so the
  // existing CSS rules continue to match.
  if (typeof document !== "undefined") {
    document.body.className = `page page--${activePage}`;
  }

  return (
    <>
      <IconSprite />
      <div className="app-shell">
        <Sidebar />
        <main className="app-main">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={pathname}
              initial={reduce ? false : { opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={reduce ? undefined : { opacity: 0, y: -6 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              style={{ height: "100%" }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
        <TabBar />
      </div>
    </>
  );
}
